import { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { ICollectionSearchResults, ICollection } from "services/types";
import { CollectionTile } from "./CollectionTile";
import { RawCollectionTile } from "./RawCollectionTile";
import { apiCollections } from "services";
import { routes } from "routes";

import LikedIcon from "components/icons/LikedIcon.svg";

import "./CollectionsList.scss";

const PAGE_SIZE = 50;

export const CollectionsList = (props: {
  userName: string;
  showSaved: boolean;
}): JSX.Element => {
  const [pagesRead, setPagesRead] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [items, setItems] = useState<ICollection[]>([]);
  const [error, setError] = useState<string|null>(null);
  const [ready, setReady] = useState<boolean>(false);

  const fetch = useCallback((page: number) => {
    apiCollections.getUserCollections({
      userId: props.userName,
      page: page,
      count: PAGE_SIZE,
    }).then((data: ICollectionSearchResults) => {
      if (data.page <= pagesRead) {
        console.debug(`[collections] Read user=${props.userName} page=${data.page} of=${data.pages} (again).`);
      } else {
        console.debug(`[collections] Read user=${props.userName} page=${data.page} of=${data.pages}.`);

        setItems(old => [...old, ...data.collections]);
        setPagesRead(data.page);
        setHasMore(data.page < data.pages);
        setError(null);
      }
    }).catch((e: any) => {
      console.error(`[collections] Error reading data: ${e}.`);
      setError(e.message);
    });
  }, [pagesRead, props.userName]);

  useEffect(() => {
    if (!ready) {
      setReady(true);
      fetch(1);
    }
  }, [ready, fetch]);

  const fetchMore = () => {
    fetch(pagesRead + 1);
  };

  if (error) {
    return <p>Error reading collections.</p>;
  }

  return (
    <div className="collections">
      <InfiniteScroll
        dataLength={items.length}
        hasMore={hasMore}
        next={fetchMore}
        loader={<></>}
      >
        <div className="tiles">
          {props.showSaved && (
            <RawCollectionTile
              link={routes.favourites()}
              thumbnail={LikedIcon}
              published={false}
              label="Likes"
            />
          )}

          {items.map((item: ICollection, index: number) => (
            <CollectionTile
              key={item.folderId}
              userName={props.userName}
              collection={item}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
};
